import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Componentes() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('comp_title')}
          </h1>
        </div>

        {/* Transportador */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-blue-600">{t('comp_conveyor')}</h2>
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('comp_conveyor_desc')}
              </p>
              
              <h3 className="text-xl font-semibold mb-4">{t('comp_conveyor_parts')}</h3>
              <div className="space-y-3">
                {[
                  t('comp_motor'),
                  t('comp_inverter'),
                  t('comp_rollers'),
                  t('comp_bearings'),
                  t('comp_belt'),
                  t('comp_sensors'),
                  t('comp_safety'),
                  t('comp_plc_control')
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-settings-line text-blue-600"></i>
                    </div>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/4760f694d63e9360977f41efed2c9038.jpg"
                alt={t('comp_conveyor')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* PLC */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-green-600">{t('comp_plc_title')}</h2>
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <div className="bg-green-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold mb-3">{t('comp_plc_def')}</h3>
                <p className="text-gray-700">
                  {t('comp_plc_def')}
                </p>
              </div>

              <h3 className="text-xl font-semibold mb-4">{t('comp_plc_functions')}</h3>
              <div className="space-y-4">
                {[
                  { icon: 'ri-radio-line', text: t('comp_plc_func1') },
                  { icon: 'ri-settings-4-line', text: t('comp_plc_func2') },
                  { icon: 'ri-error-warning-line', text: t('comp_plc_func3') },
                  { icon: 'ri-speed-line', text: t('comp_plc_func4') },
                  { icon: 'ri-shield-check-line', text: t('comp_plc_func5') },
                  { icon: 'ri-organization-chart', text: t('comp_plc_func6') }
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg">
                      <i className={`${item.icon} text-green-600`}></i>
                    </div>
                    <span className="text-gray-700">{item.text}</span>
                  </div>
                ))}
              </div>

              <div className="bg-red-50 p-4 rounded-lg mt-6">
                <p className="text-red-800 font-medium">
                  {t('comp_plc_note')}
                </p>
              </div>
            </div>
            <div className="space-y-4">
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20PLC%20control%20panel%20in%20electrical%20cabinet%2C%20programmable%20logic%20controller%20modules%2C%20wiring%20and%20connections%2C%20professional%20industrial%20automation%20equipment%2C%20clean%20organized%20electrical%20installation&width=500&height=300&seq=plc1&orientation=landscape"
                alt={t('comp_plc_title')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Sensoren */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-purple-600">{t('comp_sensors_title')}</h2>
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('comp_sensors_desc')}
              </p>

              <h3 className="text-xl font-semibold mb-4">{t('comp_sensors_desc')}</h3>
              <div className="space-y-4">
                {[
                  t('comp_sensor1'),
                  t('comp_sensor2'),
                  t('comp_sensor3'),
                  t('comp_sensor4'),
                  t('comp_sensor5')
                ].map((sensor, index) => (
                  <div key={index} className="bg-purple-50 p-4 rounded-lg">
                    <span>{sensor}</span>
                  </div>
                ))}
              </div>

              <div className="bg-purple-50 p-4 rounded-lg mt-6">
                <p className="text-purple-800">
                  {t('comp_sensors_note')}
                </p>
              </div>
            </div>
            <div className="space-y-4">
              <img 
                src="https://readdy.ai/api/search-image?query=Photoelectric%20sensor%20detecting%20package%20on%20conveyor%20belt%2C%20industrial%20automation%20sensor%2C%20package%20detection%20system%2C%20clean%20modern%20logistics%20facility%2C%20professional%20sensor%20equipment&width=500&height=300&seq=sensor1&orientation=landscape"
                alt={t('comp_sensors_title')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Motoren & Drives */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-orange-600">{t('comp_motors_title')}</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-orange-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-3">{t('comp_motor')}</h3>
              <p className="text-gray-700">
                {t('comp_motor_desc')}
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-3">{t('comp_inverter')}</h3>
              <p className="text-gray-700">
                {t('comp_drive_desc')}
              </p>
            </div>
          </div>
        </div>

        {/* Mechanische onderdelen */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-3xl font-semibold mb-6 text-indigo-600">{t('comp_mechanical_title')}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {[
              t('comp_mech1'),
              t('comp_mech2'),
              t('comp_mech3'),
              t('comp_mech4'),
              t('comp_mech5'),
              t('comp_mech6')
            ].map((component, index) => (
              <div key={index} className="bg-indigo-50 p-4 rounded-lg">
                <h4 className="font-semibold text-indigo-800">{component}</h4>
              </div>
            ))}
          </div>
          
          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-yellow-800">
              {t('comp_mech_note')}
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/introducao"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_intro')}
          </Link>
          <Link 
            to="/funcionamento"
            className="flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_operation')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
